import styles from "./index.module.scss";

const CustomerData = () => {
  return (
    <div className={styles["customer-data"]}>
      <iframe
        allow="clipboard-write;camera;geolocation;fullscreen"
        frameBorder="0"
        src="https://apps.honganh.vn/embed/cskh"
        title="Dữ liệu khách hàng"
      />
    </div>
  );
};

export default CustomerData;
